// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import BAlertBar from 'ui/blocks/AlertBar'

const AlertBar = ({ type, icon, noBorder, modifiers, children }) => {
  const nestedModifiers = typeof modifiers === 'object' ? modifiers : { self: modifiers }

  const displayIcon = icon || {
    danger: 'times-circle',
    warning: 'exclamation-triangle',
    success: 'check-circle',
    info: 'info-circle'
  }[type]

  return (
    <BAlertBar type={type} noBorder={noBorder} modifiers={nestedModifiers.self}>
      <BAlertBar.Icon icon={displayIcon} modifiers={nestedModifiers.icon} />
      {children}
    </BAlertBar>
  )
}

AlertBar.propTypes = {
  type: PropTypes.oneOf(['info', 'warning', 'danger', 'success']).isRequired,
  icon: PropTypes.string,
  noBorder: PropTypes.bool,
  children: PropTypes.node,
  modifiers: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
}

export default AlertBar
